import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { StorageModule } from '@ngx-pwa/local-storage';
import { NgAuthModule } from '@principle-theorem/ng-auth';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { AccountActionsComponent } from './account-actions/account-actions.component';
import { AppAccountActionsComponent } from './app-account-actions/app-account-actions.component';
import { AuthPageComponent } from './auth-page/auth-page.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { UnauthorisedComponent } from './unauthorised/unauthorised.component';
import { UserActivateComponent } from './user-activate/user-activate.component';
import { RegisterPageComponent } from './register-page/register-page.component';
import { UserRestrictedComponent } from './user-restricted/user-restricted.component';
import { WorkspacesComponent } from './workspaces/workspaces.component';
import { NgPrincipleModule } from '@principle-theorem/ng-principle';

@NgModule({
  declarations: [
    AppAccountActionsComponent,
    AccountActionsComponent,
    SignUpComponent,
    UserActivateComponent,
    WorkspacesComponent,
    UserRestrictedComponent,
  ],
  imports: [
    CommonModule,
    NgAuthModule,
    NgPrincipleModule,
    StorageModule,
    NgSharedModule,
    ReactiveFormsModule,
    AuthPageComponent,
    RegisterPageComponent,
    UnauthorisedComponent,
  ],
  exports: [AccountActionsComponent],
})
export class AuthPagesModule {}
